/*
 * Konfiguration für das DOCUNIZE SunnySign Add-In
 */

// API Base URL - kann über Umgebungsvariable überschrieben werden
// Standard: https://localhost:5001 (Backend Development Server)
// Webpack DefinePlugin ersetzt API_BASE_URL_VALUE zur Build-Zeit als String-Literal

// @ts-ignore - Webpack DefinePlugin ersetzt diese Variable zur Build-Zeit
// Ohne abschließenden Slash, damit ${API_BASE_URL}/api/... keine doppelten Slashes ergibt
export const API_BASE_URL: string = String(API_BASE_URL_VALUE).replace(/\/+$/, "");

// Azure AD / OAuth für Consent im Taskpane (gleiche App wie im Manifest WebApplicationInfo)
// @ts-ignore - Webpack DefinePlugin ersetzt diese Variable zur Build-Zeit
export const AUTH_CLIENT_ID: string = AUTH_CLIENT_ID_VALUE;

// API Endpunkte
export const API_ENDPOINTS = {
  SIGNATURES: `${API_BASE_URL}/api/signatures`,
};

/** Basis-URL für Premium-/Upgrade-Seiten (z. B. Kampagnen, Organisation). Klick auf Schloss öffnet diese. */
export const PREMIUM_BASE_URL = "https://sunnysign.docunize.com";
